import * as THREE from "three";
import { Spawnable } from "./Spawnable";

export function intersectsSpawnable(
  playerBox: THREE.Box3,
  s: Spawnable,
): boolean {
  const p = s.mesh.position;
  let minY = p.y - s.halfExtents.y;
  let maxY = p.y + s.halfExtents.y;

  if (s.kind === "coin" || s.kind === "magnet" || s.kind === "shield" || s.kind === "nitro" || s.kind === "x2") {
    // Slightly forgiving pickup box
    minY -= 0.1;
    maxY += 0.4;
  }

  if (playerBox.max.x < p.x - s.halfExtents.x) return false;
  if (playerBox.min.x > p.x + s.halfExtents.x) return false;
  if (playerBox.max.y < minY) return false;
  if (playerBox.min.y > maxY) return false;
  if (playerBox.max.z < p.z - s.halfExtents.z) return false;
  if (playerBox.min.z > p.z + s.halfExtents.z) return false;
  return true;
}
